export default __webpack_public_path__ + "static/media/failed.98e8f364.svg";